import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const AnnouncedDefault: FC<SvgIconProps> = ({ viewBox = '0 0 254 170', ...props }) => (
  <SvgIcon viewBox={viewBox} {...props} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.5"
      d="M82.1845 145.865L109.115 140.54L63.619 117.805L36.6889 123.131L82.1845 145.865Z"
      fill="url(#announced_paint0_linear)"
    />
    <path d="M109.115 68.239L189.089 53.9016L143.593 31.1667L63.619 45.504L109.115 68.239Z" fill="#FDDE84" />
    <path
      opacity="0.4"
      d="M89.529 58.4076L169.503 44.0703L161.955 40.3835L81.7764 54.7209L89.529 58.4076Z"
      fill="#AA7B33"
    />
    <path d="M109.115 68.239V140.54L63.619 117.805V45.504L109.115 68.239Z" fill="#C39000" />
    <path opacity="0.4" d="M89.529 58.4076V74.1787L81.7764 70.0823V54.7209L89.529 58.4076Z" fill="#AA7B33" />
    <path d="M109.115 68.239V140.54L189.089 125.998V53.9016L109.115 68.239Z" fill="#FCCE09" />
    <path d="M132.576 98.1426V125.179L179.296 116.781V89.745L132.576 98.1426Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M159.507 115.143C162.363 114.733 165.015 114.118 167.667 113.709C167.667 108.384 167.667 102.853 167.667 97.5281C165.015 97.9378 162.159 98.5522 159.507 98.9619C159.507 104.287 159.507 109.817 159.507 115.143Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M136.861 119.034C139.309 118.624 141.553 118.215 143.797 117.805C143.797 112.48 143.797 106.95 143.797 101.624C141.349 102.034 139.105 102.444 136.861 102.853C136.861 108.384 136.861 113.709 136.861 119.034Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M151.55 116.576C152.774 116.371 153.794 116.167 155.018 115.962C155.018 110.637 155.018 105.106 155.018 99.7811C153.794 99.9859 152.774 100.191 151.55 100.396C151.55 105.721 151.55 111.046 151.55 116.576Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M174.808 96.2992C173.584 96.504 172.564 96.7088 171.339 96.9137C171.339 102.444 171.339 107.769 171.339 113.094C172.564 112.89 173.584 112.685 174.808 112.48C174.808 106.95 174.808 101.625 174.808 96.2992Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M147.674 117.191C148.082 117.191 148.49 116.986 149.102 116.986C149.102 111.661 149.102 106.131 149.102 100.805C148.49 100.805 148.082 101.01 147.674 101.01C147.674 106.54 147.674 111.865 147.674 117.191Z"
      fill="black"
    />
    <path d="M181.54 105.106L130.128 114.323V110.841L181.54 101.625V105.106Z" fill="#D40511" fillOpacity="0.8" />
    <defs>
      <linearGradient
        id="announced_paint0_linear"
        x1="65.485"
        y1="136.251"
        x2="72.7724"
        y2="120.752"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.25" stopOpacity="0" />
        <stop offset="0.598958" stopOpacity="0.3" />
        <stop offset="1" stopOpacity="0.8" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
